import { render, staticRenderFns } from "./PastAnalysesList.vue?vue&type=template&id=d8404dda&scoped=true"
import script from "./PastAnalysesList.vue?vue&type=script&lang=js"
export * from "./PastAnalysesList.vue?vue&type=script&lang=js"
import style0 from "./PastAnalysesList.vue?vue&type=style&index=0&id=d8404dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8404dda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLazy,VPagination,VRow})
